
import { TranslationRecord } from '../../types';

export const cookieConsent: TranslationRecord = {
  // Cookie Consent
  cookieConsentTitle: 'Συγκατάθεση Cookies',
  cookieConsentDescription: 'Χρησιμοποιούμε cookies για τη βελτίωση της εμπειρίας περιήγησης, την ανάλυση της επισκεψιμότητας και την εξατομίκευση περιεχομένου. Κάνοντας κλικ στο "Αποδοχή Όλων", συναινείτε στη χρήση των cookies όπως περιγράφεται στην Πολιτική Cookie μας.',
  acceptAll: 'Αποδοχή Όλων',
  rejectAll: 'Απόρριψη Όλων',
  managePreferences: 'Διαχείριση',
  savePreferences: 'Αποθήκευση',
  cancel: 'Ακύρωση',
  
  // Cookie Preferences
  cookiePreferencesTitle: 'Προτιμήσεις Cookies',
  cookiePreferencesDescription: 'Διαχειριστείτε τη χρήση των cookies. Τα απαραίτητα cookies δεν μπορούν να απενεργοποιηθούν.',
  
  // Cookie Types
  necessaryCookies: 'Απαραίτητα Cookies',
  necessaryCookiesDescription: 'Απαραίτητα για τη λειτουργία του ιστότοπου.',
  
  functionalCookies: 'Λειτουργικά Cookies',
  functionalCookiesDescription: 'Επιτρέπουν βελτιωμένη λειτουργικότητα και εξατομίκευση.',
  
  analyticsCookies: 'Cookies Ανάλυσης',
  analyticsCookiesDescription: 'Βοηθούν στην κατανόηση της αλληλεπίδρασης των επισκεπτών με τον ιστότοπο.',
  
  marketingCookies: 'Cookies Μάρκετινγκ',
  marketingCookiesDescription: 'Χρησιμοποιούνται για την εμφάνιση σχετικών διαφημίσεων.',
  
  // Cookie Policy
  cookiePolicyIntro: 'Εισαγωγή',
  cookiePolicyEffectiveDate: 'Ημερομηνία Έναρξης Ισχύος',
  cookiePolicyDescription: 'Αυτή η Πολιτική Cookies εξηγεί πώς χρησιμοποιούμε cookies και παρόμοιες τεχνολογίες, γιατί τις χρησιμοποιούμε και τα δικαιώματά σας.',
  
  whatAreCookies: 'Τι Είναι τα Cookies;',
  cookieDefinition: 'Τα cookies είναι μικρά αρχεία δεδομένων που τοποθετούνται στη συσκευή σας όταν επισκέπτεστε έναν ιστότοπο.',
  cookiePurpose: 'Τα cookies πρώτου μέρους ορίζονται από εμάς, ενώ τα cookies τρίτων επιτρέπουν λειτουργίες τρίτων στον ιστότοπό μας.',
  
  cookieTypes: 'Τύποι Cookies που Χρησιμοποιούμε',
  analyticsSpecificCookies: 'Τα cookies ανάλυσης που χρησιμοποιούμε περιλαμβάνουν',
  
  managingCookies: 'Διαχείριση των Προτιμήσεων Cookie',
  managingCookiesDescription: 'Μπορείτε να αλλάξετε τις προτιμήσεις σας οποιαδήποτε στιγμή μέσω του κουμπιού παρακάτω ή μέσω του προγράμματος περιήγησής σας.',
  manageCookiePreferences: 'Διαχείριση Προτιμήσεων Cookie',
  browserSettings: 'Τα περισσότερα προγράμματα περιήγησης σάς επιτρέπουν να ελέγχετε τα cookies μέσω των ρυθμίσεών τους:',
  
  contactUs: 'Επικοινωνήστε Μαζί Μας',
  cookiePolicyContact: 'Εάν έχετε ερωτήσεις σχετικά με τη χρήση των cookies, επικοινωνήστε μαζί μας',
  lastUpdated: 'Τελευταία Ενημέρωση',
  cookiePolicy: 'Πολιτική Cookie',
  privacyPolicy: 'Πολιτική Απορρήτου',
};
